import { apiClient } from '../apiClient';

export interface TopicMessage {
  id: string;
  batch_id: string;
  batch_topic_id: string;
  student_id: string;
  sender_id: string;
  body: string;
  created_at: string;
}

export interface TopicThreadData {
  messages: TopicMessage[];
  self: string;
}

export interface TopicThreadPreview {
  batch_topic_id: string;
  student_id: string;
  student_name: string;
  topic_title: string;
  last_body: string;
  last_at: string;
  batch_id: string;
  batch_name: string;
  /** Who sent the latest message; when === student_id the thread awaits a trainer reply. */
  last_sender_id: string;
}

export const topicMessagesApi = {
  studentThread: async (topicId: string): Promise<TopicThreadData> => {
    const { data } = await apiClient.get('/api/v1/topic-messages', { params: { batch_topic_id: topicId } });
    return data as TopicThreadData;
  },
  trainerThread: async (topicId: string, studentId: string): Promise<TopicThreadData> => {
    const { data } = await apiClient.get('/api/v1/topic-messages', { params: { batch_topic_id: topicId, student_id: studentId } });
    return data as TopicThreadData;
  },
  send: async (body: { batch_topic_id: string; student_id?: string; body: string }): Promise<TopicMessage> => {
    const { data } = await apiClient.post('/api/v1/topic-messages', body);
    return data as TopicMessage;
  },
  inbox: async (): Promise<TopicThreadPreview[]> => {
    const { data } = await apiClient.get('/api/v1/topic-messages/inbox');
    return (data?.threads as TopicThreadPreview[]) ?? [];
  },
};
